import { AxiomReportType } from '@/enums/axiom-report.enum'
import { reportDefaultColDef } from '@/utils/grid-utils/colDefs'
import { ColDef, GridReadyEvent } from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import { Card, CardContent, CardHeader, Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import React, { useCallback } from 'react'

export type IGfpaTopBottomSecuritiesProps = {
  securitiesData: { topFiveSecurities: any[]; bottomFiveSecurities: any[] }
  securitiesDetailsColDef: ColDef[]
  reportType: string
}
export const GFPATopAndBottomFiveSecuritiesTable: React.FC<
  IGfpaTopBottomSecuritiesProps
> = ({ securitiesData, securitiesDetailsColDef, reportType }) => {
  const themeClassName = 'ag-theme-quartz'

  const onTopGridReady = useCallback((params: GridReadyEvent) => {
    if (document.body.clientWidth > 1400) {
      params.api.sizeColumnsToFit()
    } else {
      params.api.autoSizeAllColumns();
    }
  }, []);

  const onBottomGridReady = useCallback((params: GridReadyEvent) => {
    if (document.body.clientWidth > 1400) {
      params.api.sizeColumnsToFit();
    } else {
      params.api.autoSizeAllColumns();
    }
  }, []);

  return (
    <Stack direction='column' gap={0}>
      <Card elevation={0}>
        <CardHeader
          sx={{ p: 0 }}
          title={
            <Typography variant='h3'>
              {`Top 5 Contributors to ${reportType === AxiomReportType.GFR ? 'Risk' : 'Returns'}`}
            </Typography>
          }
        />
        <CardContent sx={{ p: 0 }}>
          <div className={`${themeClassName} ag-mh-14`}>
            <AgGridReact
              domLayout='autoHeight'
              onGridReady={onTopGridReady}
              defaultColDef={{ ...reportDefaultColDef, filter: false }}
              columnDefs={securitiesDetailsColDef}
              rowData={securitiesData?.topFiveSecurities}
              data-cy={`${reportType?.toLowerCase()}-top-five-securites`}
            />
          </div>
        </CardContent>
      </Card>
      <Card elevation={0}>
        <CardHeader
          sx={{ p: 0 }}
          title={
            <Typography variant='h3'>
              {`Bottom 5 Contributors to ${reportType === AxiomReportType.GFR ? 'Risk' : 'Returns'}`}
            </Typography>
          }
        />
        <CardContent sx={{ p: 0 }}>
          <div className={`${themeClassName} ag-mh-14`}>
            <AgGridReact
              domLayout='autoHeight'
              onGridReady={onBottomGridReady}
              defaultColDef={{ ...reportDefaultColDef, filter: false }}
              columnDefs={securitiesDetailsColDef}
              rowData={securitiesData?.bottomFiveSecurities}
              data-cy={`${reportType?.toLowerCase()}-bottom-five-securites`}
            />
          </div>
        </CardContent>
      </Card>
    </Stack>
  )
}
